// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"JO-z","categoryName":"KO-z","categoryNameSearchHeader":"LO-z","categoryContent":"MO-z","bottomAligned":"NO-z","image":"OO-z","imageNoBackground":"PO-z"};